import { actions } from '../../utils/constants';

export const fetchClasses = () => ({
    type: actions.ASYNC_FETCH_CLASSES,
});

export const createClass = (
    classId,
    className,
    courseId,
    trainerId,
    centerId,
    typeTestsValues,
) => ({
    type: actions.ASYNC_CREATE_CLASS,
    payload: {
        classId,
        className,
        courseId,
        trainerId,
        centerId,
        typeTestsValues,
    },
});

export const deleteClass = classId => ({
    type: actions.ASYNC_DELETE_CLASS,
    payload: classId,
});

export const asyncFetchClassTemplateTests = ({ classId }) => ({
    type: actions.ASYNC_FETCH_CLASS_TEMPLATE_TESTS,
    payload: {
        classId,
    },
});



// WEBPACK FOOTER //
// ./src/components/classes/classes.actions.js